<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { SCIcon } from '@nsftx/seven-components'
import STWalletBalanceDetailsHeader from './STWalletBalanceDetailsHeader.vue'
import STWalletBalanceLastTransactions from './STWalletBalanceLastTransactions.vue'
import STWalletBalanceVisibilityToggle from './STWalletBalanceVisibilityToggle.vue'
import { useWalletStore } from '@/stores/wallet/walletStore'
import { useWalletBalanceStore } from '@/stores/wallet/walletBalanceStore'
import { formatNumber, getCurrencySymbol } from '@nsftx/seven-nxg-retail-vue-sdk'

// stores
const { wallets } = storeToRefs(useWalletStore())
const { isWalletBalanceVisible } = storeToRefs(useWalletBalanceStore())

// computeds
const formattedBalanceWithTwoDecimals = computed(() =>
  isWalletBalanceVisible.value
    ? formatNumber(wallets.value?.[0]?.balance || '0', {
        style: 'currency',
        currencySymbol: getCurrencySymbol(wallets.value?.[0]?.currency || '')
      })
    : `* * * * ${getCurrencySymbol(wallets.value?.[0]?.currency || '')}`
)
</script>

<template>
  <div class="st-wallet-balance-details__single st-d-flex-column">
    <STWalletBalanceDetailsHeader>
      <template #icon-left>
        <SCIcon icon="n-i-bills" size="2xl" color="var(--sc-main-primary)" />
      </template>
      <template #title>{{ $t('common_total_balance') }}</template>
      <template #value
        ><span data-testid="formattedBalanceWithTwoDecimals">{{
          formattedBalanceWithTwoDecimals
        }}</span></template
      >
      <template #icon-right>
        <STWalletBalanceVisibilityToggle />
      </template>
    </STWalletBalanceDetailsHeader>
    <STWalletBalanceLastTransactions />
  </div>
</template>
